import React, {useEffect} from 'react';
import {Row, Col, List, Card, Button, Modal,Drawer} from 'antd'
import { useSelector, useDispatch } from 'react-redux';
import NumberFormat from 'react-number-format';
import {Link} from 'react-router-dom'
import { actionGetProducts } from '../../store/acciones/accionesProductos';
import item_product from '../../assets/images/item_product.png'
import './styles.css';



const renderImage = (item) => {
    var extension = '.pdf';
    if( item.image_product && item.image_product.length > 0 ){
        let filterImageExtension = item.image_product.filter(function (file) {
            return file.image_product.indexOf(extension) == -1;
        });
        console.log(filterImageExtension)
        if(filterImageExtension && filterImageExtension.length > 0){
            return <img src={filterImageExtension[0].image_product} style={{ width: "100%", height: "100%", objectFit: "contain" }} alt={item.nombre_producto} />
        }
    }
    
    else
        return <img src={item_product} style={{ width: "80%", height: "80%", objectFit: "contain" }} alt={item.nombre_producto} />
}

const ProductsList = (props) => {
    let productos = useSelector(state => state.reducerProductos.entities);
    let configTarifas = useSelector(state => state.reducerProductos.configTarifas);
    let totalProducts = useSelector(state => state.reducerProductos.total);
    const dispatch = useDispatch(); 

    useEffect(() => {
        dispatch(actionGetProducts(1))
    }, [dispatch])
    
    console.log(productos)
    return (
        <div className="divSection">
            <div className="container-fluid">
                <div className="logo" > 
                    <h1><a href="#intro" className="scrollto">NFH</a></h1>
                </div>
                <nav className="nav-menu-container">
                    <ul className="nav-menu">
                        <li><a href="http://www.nfh.com.mx/#intro">Inicio</a></li>
                        <li><a href="http://www.nfh.com.mx/#about">Nosotros</a></li>
                        <li><a href="http://www.nfh.com.mx/#services">Servicios</a></li>
                        <li><a href="http://www.nfh.com.mx/#portfolio">Productos</a></li>
                        <li><a href="http://www.nfh.com.mx/#sucursales">Sucursales</a></li>
                        <li><a href="http://www.nfh.com.mx/#contact">Contacto</a></li>
                        <li className="menu-active"><a href="#">Catalogo</a></li>
                    </ul>
                </nav>
            </div>
            <Row type="flex" justify="space-around" align="middle" style={{marginTop:"100px", marginBottom:"40px"}}>
            <List
                     pagination={{
                        total:totalProducts,
                        onChange: page => {
                            dispatch(actionGetProducts(page))
                        },
                        pageSize: 40,
                        position:'top'
                      }}
                        grid={{
                            gutter: 16,
                            xs: 1,
                            sm: 3,
                            md: 4,
                            lg: 4,
                            xl: 4,
                            xxl: 4,
                        }}
                        dataSource={productos}
                        renderItem={item => (
                            <List.Item>
                                <Card style={{height:200, marginBottom:50}}> 
                                    <Row type="flex"  justify="space-around" align="middle" gutter={48} style={{flexDirection:"column", height:"100%"}} >
                                        <Col xs={24}>
                                            <span style={{ fontSize:16, fontWeight: "bold", letterSpacing: "1px"}}>{item.nombre_producto}</span>                                     
                                        </Col>
                                        <Col xs={24} style={{width:"60%", height:"100px", display:"flex", justifyContent:"center", alignItems:"center"}}>
                                            {
                                              renderImage(item)
                                            }                                       
                                        </Col>
                                        
                                        <Col  xs={24} style={{display:"flex",flexDirection:"column", justifyContent:"flex-start", paddingLeft:"30px", width:"100%"}}>
                                            {
                                                item &&                                  
                                                <span style={{ fontSize: 16, fontWeight: "700", letterSpacing: "1.5px",marginBottom:"10px" }}>{item.descripcion_producto}</span>
                                            }
                                            {/* <div style={{display:"flex", justifyContent:"space-around", alignItems:"center", marginBottom:"20px"}}>
                                                <span style={{fontSize:30, fontWeight:"800", letterSpacing:"1px", margin:"10 0 10 0"}}> <NumberFormat value={item.precio_publico} displayType={'text'}  thousandSeparator={true} prefix={'$'} decimalScale={2}/></span> 
                                                <span style={{fontSize:18, fontWeight:"800", letterSpacing:"1px", margin:"10 0 10 0"}}>{item.medida_producto}</span> 
                                            </div>
                                            */}
                                        </Col>
                                        <Col xs={24} style={{display:"flex", flexDirection:"row", justifyContent:"space-around", alignItems:"center"}}>
                                            <Link to={`/productos/${item.id}`} >
                                                <Button type="primary" icon="file" size="small">Detalle del producto</Button>
                                            </Link>
                                        </Col>
                                    </Row>
                                    
                                </Card>
                            </List.Item>
                        )}
                    />
            </Row>

        </div>

    );
};

export default ProductsList;